import React, { useContext } from 'react'
import styled from 'styled-components'
import { navigate } from 'gatsby'

import CMS from '@talus-analytics/library.airtable-cms'

import StyledTypeaheadControl from 'components/ui/StyledTypeaheadControl'
import TypeaheadResult from 'components/ui/TypeaheadResult'

import { useLandingPageData } from 'cmsHooks'
import { useExploreTableResources } from 'dataHooks'
import { ConfigContext } from 'components/context/ConfigProvider'
import { templateURL } from 'components/navigation/TemplateLink'

const SearchControls = styled.div`
  display: flex;
  align-items: baseline;
  width: 100%;
  max-width: 900px;
`
const SearchBoxContainer = styled.div`
  flex-grow: 1;
`

interface ResourceSearchProps {
  // bool for whether resource search is in Nav bar or not
  nav?: boolean
}
const ResourceSearch = ({ nav = false }: ResourceSearchProps): JSX.Element => {
  const config = useContext(ConfigContext)
  if (!config) {
    throw new Error('Config is null or undefined from ConfigContext.')
  }

  const resourceUrlTemplate = config.siteMap.detail.urlTemplate
  if (!resourceUrlTemplate) {
    throw new Error('No urlTemplate found on siteMap.detail')
  }

  const landingData = useLandingPageData()
  const resourceSearchData = useExploreTableResources()

  const resources = resourceSearchData.nodes
    .map(r => ({
      key: r.data.Title,
      label: r.data.Title,
      // need to pass all data in case certain attributes
      // are used in the templateURL function
      ...r.data,
    }))
    .sort((a, b) => a.Title.localeCompare(b.Title))

  return (
    <SearchControls>
      <SearchBoxContainer>
        <StyledTypeaheadControl
          landing
          nav={nav}
          placeholder={CMS.getText(landingData, 'Search placeholder') ?? ''}
          items={resources}
          values={[]}
          onAdd={resource => {
            if (resource) navigate(templateURL(resource, resourceUrlTemplate))
          }}
          onRemove={() => {}}
          RenderItem={({ item: { label } }) => (
            <TypeaheadResult>{label}</TypeaheadResult>
          )}
        />
      </SearchBoxContainer>
    </SearchControls>
  )
}

export default ResourceSearch
